export default __webpack_public_path__ + "static/media/Love08.05cc2e44.png";